import React from 'react';
import { motion } from 'framer-motion';
import { ChevronRight } from 'lucide-react';
import { Button } from './ui/button';

const groupPhotos = [
  {
    src: 'https://static.prod-images.emergentagent.com/jobs/0db38a4d-9eca-46f0-9975-4175ea5b16fd/images/cbc978269e913ad6cf5ebee2458c7fb3a20de240af13a8faa28a72f55661a7fb.png',
    caption: 'Friends at the Hollywood Sign',
    tag: 'Hollywood Tour',
  },
  {
    src: 'https://static.prod-images.emergentagent.com/jobs/0db38a4d-9eca-46f0-9975-4175ea5b16fd/images/e6a43cd2578cc65997669ad91d6d64fa3f1cac395ee3e2e0bc09c42190af9945.png',
    caption: 'VIP Limo Experience',
    tag: 'Private Group',
  },
  {
    src: 'https://static.prod-images.emergentagent.com/jobs/0db38a4d-9eca-46f0-9975-4175ea5b16fd/images/5643d280c4b5e58ab00b7236a1254f7f623a8ed370b94fc0638936c56aa3f70d.png',
    caption: 'Beverly Hills Shopping',
    tag: 'Rodeo Drive',
  },
];

const StatsCounter = () => {
  return (
    <section className="py-20 px-4 bg-gradient-to-br from-gray-950 via-gray-900 to-gray-950 overflow-hidden" data-testid="group-gallery">
      <div className="container mx-auto max-w-6xl">
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          className="text-center mb-6"
        >
          <h2 className="text-4xl sm:text-5xl font-black text-white mb-3" style={{ fontFamily: "'Playfair Display', serif" }}>
            Why We're <span className="text-transparent bg-clip-text bg-gradient-to-r from-yellow-600 to-yellow-500">Hollywood's #1</span>
          </h2>
          <p className="text-white/40 text-base max-w-xl mx-auto">Trusted by travelers worldwide</p>
        </motion.div>

        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ delay: 0.2 }}
          className="text-center mb-10"
        >
          <p className="text-xs tracking-[0.3em] uppercase text-yellow-500/70 font-semibold mb-2">Real Guests, Real Memories</p>
          <h3 className="text-2xl sm:text-3xl font-black text-white" style={{ fontFamily: "'Playfair Display', serif" }}>
            Unforgettable <span className="gold-gradient-text">Group Experiences</span>
          </h3>
          <p className="text-sm text-white/35 max-w-lg mx-auto mt-2">Join thousands of happy travelers who chose Hollywood Fame Tour for their group adventure</p>
        </motion.div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-5">
          {groupPhotos.map((photo, idx) => (
            <motion.div
              key={idx}
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ delay: idx * 0.15 }}
              className="group relative rounded-2xl overflow-hidden aspect-[4/3] cursor-pointer"
            >
              <img
                src={photo.src}
                alt={photo.caption}
                className="w-full h-full object-cover group-hover:scale-110 transition-transform duration-700"
                loading="lazy"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-black/70 via-transparent to-transparent" />
              <div className="absolute bottom-0 left-0 right-0 p-5">
                <span className="inline-block px-3 py-1 bg-yellow-500/20 backdrop-blur-md border border-yellow-500/30 rounded-full text-[10px] tracking-[0.2em] uppercase text-yellow-300 font-semibold mb-2">{photo.tag}</span>
                <p className="text-white font-bold text-lg" style={{ fontFamily: "'Playfair Display', serif" }}>{photo.caption}</p>
              </div>
            </motion.div>
          ))}
        </div>

        <motion.div
          initial={{ opacity: 0 }}
          whileInView={{ opacity: 1 }}
          viewport={{ once: true }}
          className="text-center mt-10"
        >
          <Button
            size="lg"
            data-testid="gallery-book-btn"
            className="bg-gradient-to-r from-yellow-600 to-yellow-500 hover:from-yellow-500 hover:to-yellow-400 text-black px-10 py-6 text-base font-black rounded-full shadow-[0_0_30px_rgba(212,175,55,0.3)]"
            onClick={() => document.getElementById('booking').scrollIntoView({ behavior: 'smooth' })}
          >
            Book Your Group Experience
            <ChevronRight className="ml-2 h-5 w-5" />
          </Button>
        </motion.div>
      </div>
    </section>
  );
};

export default StatsCounter;
